// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__1cIfl","colCheckbox":"styles_colCheckbox__2rY9q"};